import {makeLxTranslations} from "@lxo-blocks/react";


const SIGNIN_BASE_LAYOUT_TRANSLATION = makeLxTranslations({
    namespace: "signInBaseLayoutTranslations",
    translations: {
        CREDENTIALS: "Willkommen bei lexoffice",
        CREDENTIALS_subtitle: "",

        RESET_MFA: "Mit Ersatzcode anmelden",
        RESET_MFA_subtitle: "",

        MFA: "Anmeldung in zwei Schritten",
        MFA_subtitle: "Zum besseren Schutz Ihres Benutzerkontos möchte lexoffice Ihre Identität überprüfen.",

        MFA_PUSH: "Anmeldung in zwei Schritten",
        MFA_PUSH_subtitle: "Zum besseren Schutz Ihres Benutzerkontos möchte lexoffice Ihre Identität überprüfen.",

        CHANGE_METHOD: "Anmeldung in zwei Schritten",
        CHANGE_METHOD_subtitle: "Zum besseren Schutz Ihres Benutzerkontos möchte lexoffice Ihre Identität überprüfen.",

        SET_PASSWORD_subtitle: "Bitte vergeben Sie hier ein Passwort für Ihren Login bei lexoffice",
        SET_PASSWORD: "Passwort festlegen",

        ENTER_NEW_PASSWORD: "Neues Passwort festlegen",
        ENTER_NEW_PASSWORD_subtitle: "Bitte vergeben Sie hier ein neues Passwort für Ihren Login bei lexoffice",

        FORGOT_PASSWORT_EMAIL: "Passwort vergessen? Kein Problem!",
        FORGOT_PASSWORT_EMAIL_subtitle: "Bitte tragen Sie die E-Mail-Adresse ein, mit der Sie sich bei lexoffice registriert haben.",

        FORGOT_PASSWORT_EMAIL_SUCCESS: "Neues Passwort angefordert",
        FORGOT_PASSWORT_EMAIL_SUCCESS_subtitle: "",
    }
});

export {SIGNIN_BASE_LAYOUT_TRANSLATION};
